import { yup, yupResolver } from '@sahinyazilim/sahinyazilim-components';

export const ContactFormYup = yupResolver<any>(
  yup
    .object({
      subject: yup.string().min(3).required(),
      message: yup.string().min(5).required(),
    })
    .required(),
);
